import { Button, Col, DatePicker, Form, Input, Row, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UploadOutlined } from '@ant-design/icons'
import { HostelFeePaymentAPI } from '../../../AllAPI/StudentAPI'
import axios from 'axios'
import QRCodeImg from "../../../Assets/QRCode.jpeg"
const { Option } = Select

const HostelFeePayment = () => {
  const navigate = useNavigate()

  //---------------------------------Disabled back button-------------------------------
  useEffect(() => {
    window.history.pushState(null, null, window.location.href)

    const handleBackButton = (event) => {
      event.preventDefault()
      window.history.forward()
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  const location = useLocation()
  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )

  const RegId = formDataFromStorage.reg_id
  const Status = formDataFromStorage.status
  const BranchId = formDataFromStorage.branch_id
  const BoardingYear = formDataFromStorage.year
  const HostelFeeAmount = formDataFromStorage.pay_hostel_fee
  const ConcessionFlag = formDataFromStorage.concession_flag
  

  const [payMode, setPayMode] = useState('')
  const [amount, setAmount] = useState(HostelFeeAmount)
  const [taxId, setTaxId] = useState('')
  const [taxImg, setTaxImg] = useState(null)
  const [paymentDate, setPaymentDate] = useState('')

  const handleImageUpload = (info) => {
    const file = info.fileList?.[0]?.originFileObj

    if (file) {
      setTaxImg(file) // correct File object
    } else {
      toast.warn('Upload Image')
    }
  }

  const handleSubmit = async () => {
    const fd = new FormData()
    fd.append('hostel_pay_mode', payMode)
    fd.append('hostel_pay_amount', amount)
    fd.append('hostel_tax_id', taxId)
    fd.append('hostel_pay_date', paymentDate?.format('YYYY-MM-DD'))
    fd.append('hostel_tax_image', taxImg)
    fd.append('hostel_payment_year', new Date().getFullYear())
    fd.append('hostelPay_approval', 1) //pending==1, but not approved by admin
    fd.append('year', BoardingYear)

    try {
      const res = await axios.put(`${HostelFeePaymentAPI}/${RegId}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      if (res.data == 'ERROR') {
        toast.warn('Error Occurred!!')
      } else if (res.data == 'SAVED') {
        navigate('/student/login')
        toast.success('Payment Successful, Waiting for Admin Approval!')
      }
    } catch (err) {
      toast.error('Error while submitting payment')
    }
  }

  const handleReset = () => {
    setPayMode('')
    setAmount(HostelFeeAmount)
    setTaxId('')
    setTaxImg(null)
    setPaymentDate('')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">
              Hostel Fee Payment (ಹಾಸ್ಟೆಲ್ ಶುಲ್ಕ ಪಾವತಿ)
            </h2>
          </div>

          {Status == '3' && (
            <div className="row">
              <span style={{ color: 'red' }}>
                ( Note: Your hostel fee payment has been rejected by the admin.
                Please make the payment again. )
              </span>
              <span style={{ color: 'red' }}>
                ( ಗಮನಿಸಿ: ನಿಮ್ಮ ಹಾಸ್ಟೆಲ್ ಶುಲ್ಕ ಪಾವತಿಯನ್ನು ನಿರ್ವಾಹಕರು
                ತಿರಸ್ಕರಿಸಿದ್ದಾರೆ. ದಯವಿಟ್ಟು ಮತ್ತೊಮ್ಮೆ ಪಾವತಿ ಮಾಡಿ. )
              </span>
            </div>
          )}

          <div className="row">
            <Row
              gutter={[16, 0]}
              className="my-2 p-2 rounded border"
              style={{ backgroundColor: '#f2f7fdff' }}
            >
              <Col xs={24} sm={8}></Col>
              <Col xs={24} sm={8} className="pt-4">
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label="Payment Mode (ಪಾವತಿ ಮೋಡ್)"
                  rules={[{ required: true, message: 'Select payment mode' }]}
                >
                  <Select
                    placeholder="Select payment mode"
                    size="large"
                    value={payMode}
                    onChange={(value) => setPayMode(value)}
                  >
                    <Option value="1">Cash</Option>
                    <Option value="2">UPI</Option>
                    <Option value="3">Online</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}></Col>

              <Col xs={24} className='text-center'>
                {ConcessionFlag == 1 && <span style={{color:"red"}}> (Note : Your fee concession has been successfully applied.) </span>}
              </Col>

              <Col xs={24} sm={8}></Col>
                <Col xs={24} sm={8} className="py-2 text-center">
                {payMode == 2 && (
                  <>
                  <img src={QRCodeImg} alt="QR Code" className='rounded shadow' style={{width:"200px",height:"200px",border:"1px solid #d1d1d1ff"}}/> <br />
                  <span>QR Code for payment</span>
                  </>
                  )}
                </Col>
                <Col xs={24} sm={8}></Col>
            </Row>

            {(payMode === '1' || payMode === '2' || payMode === '3') && (
              <Row
                gutter={[16, 0]}
                className="my-2 p-2 rounded border"
                style={{ backgroundColor: '#f2f7fdff' }}
              >
                {payMode === '1' && (
                  <>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Amount (ಮೊತ್ತ)"
                      >
                        <Input readOnly size="large" value={amount} />                        
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Receipt ID (ರಶೀದಿ ಐಡಿ)"
                        rules={[
                          { required: true, message: 'Enter receipt ID' },
                        ]}
                      >
                        <Input
                          placeholder="Enter receipt ID"
                          size="large"
                          value={taxId}
                          onChange={(e) => setTaxId(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Payment Date (ಪಾವತಿ ದಿನಾಂಕ)"
                        rules={[
                          { required: true, message: 'Select payment date' },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          onChange={(date) => setPaymentDate(date)}
                          size="large"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                          Upload Receipt Image &nbsp;
                          <span style={{ fontSize: 12 }}>
                            (ರಶೀದಿ ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ)
                          </span>
                        </div>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[{ required: true }]}
                        >
                          <Upload
                            beforeUpload={() => false}
                            onChange={handleImageUpload}
                            listType="picture"
                            maxCount={1}
                            style={{ width: '100%' }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              size="large"
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            type="primary"
                            htmlType="submit"
                            onClick={handleSubmit}
                          >
                            Proceed
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                {payMode === '2' && (
                  <>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Amount (ಮೊತ್ತ)"
                      >
                        <Input readOnly size="large" value={amount} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div style={{ marginBottom: 12,marginTop: 7, fontWeight: 500 }}>
                          UPI Transaction ID &nbsp;
                          <span style={{ fontSize: 12 }}>
                            (UPI ವಹಿವಾಟು ಐಡಿ)
                          </span>
                        </div>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[
                            {
                              required: true,
                              message: 'Enter UPI transaction ID',
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter UPI Txn ID"
                            size="large"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Payment Date (ಪಾವತಿ ದಿನಾಂಕ)"
                        rules={[
                          { required: true, message: 'Select payment date' },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          onChange={(date) => setPaymentDate(date)}
                          size="large"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                          Upload Payment Screenshot
                          <span style={{ fontSize: 12 }}>
                            (ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ)
                          </span>
                        </div>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="payment_screenshot"
                          rules={[{ required: true }]}
                        >
                          <Upload
                            beforeUpload={() => false}
                            onChange={handleImageUpload}
                            listType="picture"
                            maxCount={1}
                            style={{ width: '100%' }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              size="large"
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            type="primary"
                            htmlType="submit"
                            onClick={handleSubmit}
                          >
                            Proceed
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                {payMode === '3' && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      gap: '20px',
                      marginTop: '20px',
                      width: '100%',
                    }}
                  >
                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            type="primary"
                            style={{ backgroundColor: '#1677ff' }}
                            onClick={() =>
                              toast.info('Redirecting to online payment...')
                            }
                          >
                            Pay Now
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </Row>
            )}
          </div>

          <div className="col-12 col-md-2"></div>
        </div>
      </div>
    </div>
  )
}

export default HostelFeePayment
